import React from "react";
import { Link } from "react-router-dom";
import json_thumb from "../assets/images/json_1.jpg";
import base64_thumb from "../assets/images/base64_1.jpg";
import json_csv_thumb from "../assets/images/json_to_csv.png";

function Home() {
  return (
    <div className="container d-flex flex-column align-items-center min-vh-100">
      <h1 className="text-center mb-5">
        Welcome to{" "}
        <a
          href="https://danyal.dk"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#ffd600",
            fontWeight: "bold",
            textDecoration: "none",
          }}
        >
          danyal.dk
        </a>{" "}
        dLabs V1.0
      </h1>

      <div className="row justify-content-center w-100">
        {/* JSON Tool Card */}
        <div className="col-lg-4 col-md-6 mb-4">
          <div className="card h-100">
            <Link to="/jsonlint">
              <img src={json_thumb} className="card-img-top" alt="JSON Tool" />
            </Link>
            <div className="card-body">
              <h5 className="card-title">JSON Tool</h5>
              <p className="card-text">
                Validate, beautify, and minify JSON data with ease.
              </p>
              <Link to="/jsonlint" className="btn btn-primary">
                Go to JSON Tool
              </Link>
            </div>
          </div>
        </div>

        {/* Base64 Tool Card */}
        <div className="col-lg-4 col-md-6 mb-4">
          <div className="card h-100">
            <Link to="/base64decode">
              <img
                src={base64_thumb}
                className="card-img-top"
                alt="Base64 Tool"
              />
            </Link>
            <div className="card-body">
              <h5 className="card-title">Base64 Tool</h5>
              <p className="card-text">
                Encode and decode data using Base64 format.
              </p>
              <Link to="/base64decode" className="btn btn-primary">
                Go to Base64 Tool
              </Link>
            </div>
          </div>
        </div>

        {/* JSON to CSV Tool Card */}
        <div className="col-lg-4 col-md-6 mb-4">
          <div className="card h-100">
            <Link to="/jsontocsv">
              <img
                src={json_csv_thumb}
                className="card-img-top"
                alt="JSON to CSV Tool"
              />
            </Link>
            <div className="card-body">
              <h5 className="card-title">JSON to CSV Tool</h5>
              <p className="card-text">
                Convert JSON data to CSV format easily.
              </p>
              <Link to="/jsontocsv" className="btn btn-primary">
                Go to JSON to CSV Tool
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
